import { Record as record } from 'immutable';
import { construct, resolve } from '../../helpers/LinkMapper';
import trainTime from '../../lib/TrainTime';

const defaults = {
    Status: null,
    ProductType: null,
    OrderReference: null,
    PromotionCode: null,
    AmountPaid: null,
    Description: null,
    OriginName: null,
    originNlc: null,
    Origin: null,
    DestinationName: null,
    destinationNlc: null,
    Destination: null,
    IssuingLocationName: null,
    IssuingLocationCode: null,
    IssueDate: null,
    StartDate: null,
    ExpiryDate: null,
    TYP22ValueFlags: null,
    Class: null,
    routeCode: null,
    RouteName: null,
    RSPTicketID: null,
    TicketCode: null,
    Refundable: null,
    // KeyGo-related:
    ACCOUNT_ID: null,
    ACCOUNT_STATUS: null,
    ACCOUNT_TYPE: null,
    BALANCE: null,
    Balance: null,
    LAST_TOPUP_AMOUNT: null,
    LAST_TOPUP_DATE: null,
    TOPUP_FAILURE_COUNT: null,
    TOPUP_STATUS: null,
    TOTAL_INCOMPLETE_COUNT: null,
    PROVISIONAL_INCOMPLETE_COUNT: null,
    TravelClass: null
};

function convertToTrainTime (format) {
    return function (timeStr) {
        const datetime = trainTime(timeStr, format);
        // Workaround CMS quirks
        return datetime.isValid() && datetime.year() > 2000 ? datetime : undefined;
    };
}

export default class SmartcardProductParameters extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(SmartcardProductParameters, json, {
            Status: resolve.with(String),
            ProductType: resolve.with(String),
            OrderReference: resolve.with(String),
            PromotionCode: resolve.with(String),
            AmountPaid: resolve.with(Number),
            Description: resolve.with(String),
            OriginName: resolve.with(String),
            originNlc: resolve.with(String),
            Origin: resolve.with(String),
            DestinationName: resolve.with(String),
            destinationNlc: resolve.with(String),
            Destination: resolve.with(String),
            IssuingLocationName: resolve.with(String),
            IssuingLocationCode: resolve.with(String),
            IssueDate: resolve.with(convertToTrainTime()),
            StartDate: resolve.with(convertToTrainTime()),
            ExpiryDate: resolve.with(convertToTrainTime()),
            TYP22ValueFlags: resolve.with(String),
            Class: resolve.with(String),
            routeCode: resolve.with(String),
            RouteName: resolve.with(String),
            RSPTicketID: resolve.with(String),
            TicketCode: resolve.with(String),
            Refundable: resolve.with(String),
            target: resolve.with(String),
            expiryDateOfPasses: resolve.with(convertToTrainTime()),
            dateOfLastUsedPass: resolve.with(convertToTrainTime()),
            NumberRemainingPasses: resolve.with(Number),
            PassDuration: resolve.with(String),
            ITSOTicketID: resolve.with(String),
            ACCOUNT_ID: resolve.with(Number),
            ACCOUNT_STATUS: resolve.with(String),
            ACCOUNT_TYPE: resolve.with(String),
            BALANCE: resolve.with(Number),
            Balance: resolve.with(Number),
            LAST_TOPUP_AMOUNT: resolve.with(Number),
            LAST_TOPUP_DATE: resolve.with(convertToTrainTime('ddd MMM DD HH:mm:SS ZZZ YYYY')),
            TOPUP_FAILURE_COUNT: resolve.with(Number),
            TOPUP_STATUS: resolve.with(String),
            TOTAL_INCOMPLETE_COUNT: resolve.with(Number),
            PROVISIONAL_INCOMPLETE_COUNT: resolve.with(Number),
            TravelClass: resolve.with(String)
        });
    }

}
